import React, { Component, Fragment } from 'react';
import { Route, Routes } from 'react-router-dom'
import { withTranslation } from 'react-i18next';
import {GelContentContainer, NotFound, withAuthentication, withRouter, PageTracking} from 'cw-styleguide-react';
import axios from 'axios';
import config from './config';
import i18n from "./i18n";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { route } from "./routes";
import StepController from "./controllers/StepController";
import AnimalsController from "./controllers/AnimalsController";
import LandingController from "./controllers/LandingController";
import ResultsController from "./controllers/ResultsController";
import GaHelmet from './components/GaHelmet';

class App extends Component {
   
    render() {
  

        return (
            <Fragment>
                <PageTracking />

                <BreadcrumbsItem to={route('landing')}>
                    {this.props.t('route_app_title')}
                </BreadcrumbsItem>
                <GaHelmet>
                    <title>{this.props.t('route_app_title')}</title>
                    <meta name={'description'} content={this.props.t('app_description')} />
                </GaHelmet>
                <Routes>
                    <Route
                        index
                        element={
                            <LandingController {...this.props} />
                        }
                    />
                    {this.props.questions.map((question, index) => {
                        const isFirstStep = index === 0;
                        const isLastStep = index === this.props.questions.length - 1;

                        return (
                            <Route
                                key={index}
                                path={route(`step${question.order}`)}
                                element={
                                    <StepController
                                        {...this.props}
                                        step={question.order}
                                        previousStep={isFirstStep ? route('landing') : route(`step${question.order - 1}`)}
                                        nextStep={isLastStep ? route('result', { tab: this.props.t('results.tabs.personality.slug') }) : route(`step${question.order + 1}`)}
                                        question={question}
                                        questionIndex={index}
                                        answers={this.props.answers[index]}
                                        isLastStep={isLastStep}

                                    />
                                }
                            />
                        );
                    })}
                    <Route
                        path={route('result')}
                        element={
                            <ResultsController
                                {...this.props}

                            />
                        }
                    />
                    <Route
                        path={route('animals') + '/*'}
                        element={
                            <AnimalsController
                                {...this.props}

                            />
                        }
                    />
                    <Route path="*" element={<GelContentContainer><NotFound/></GelContentContainer>} />

                </Routes>
            </Fragment>
        );
    }
}

export default withAuthentication(withRouter(withTranslation('local')(App)));
